export const queryKey = {
    units: () => ['units'],
};
